import { Button, Dialog, DialogContent, IconButton, InputAdornment, TextField, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { shippingInvoiceColNm } from "./constant"
import { generateMenuComboItem } from "utils"
import ComboBox from "components/ComboBox"
import { initShippingInvoiceImportData } from "./initData"
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { branchApiNm } from "branch/constant/branchApiNm"
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime"
import { ArticleRounded, DocumentScannerRounded, ReplyRounded } from "resource/muiImport"
import { UserContext } from "contexts/UserContext"
import ContainerVolDialog from "./ContainerVolDialog"
import { shippingApiNm } from "./shippingApiNm"
import { endAdornmentProps } from "utils/bahtProps"
import dayjs from "dayjs"
import FileUpload from "components/FileUplaod/FileUpload"
import { saveFile } from "components/FileUplaod/saveFile"
import { alertError, alertWarning } from "components/Alert"
import Swal from "sweetalert2"
import CheckboxFormControl from "components/CheckboxFormControl"
import CustomerDialog from "pages/Menu2/CustomerManagement/CustomerDialog"
import JobDialog from "pages/Menu2/JobManagement/JobDialog"
import ReadBLDialog from "./ReadBLDialog"
import { ownCompanyCusId } from "branch/constant/shipping/shipping"


const getContSizeText = (jobOrder) => {
  let text = jobOrder.ContSize
  if (text !== "บรรทุก") {
    if (jobOrder.ContTyp === "GP") {
      if (jobOrder.ContHq === 1) {
        text = `${text}HQ`
      } else {
        text = `${text}GP`
      }
    } else if (jobOrder.ContTyp === "RF") {
      if (jobOrder.ContHq === 1) {
        text = `${text}RH`
      } else {
        text = `${text}RF`
      }
    } else {
      text = `${text}${jobOrder.ContTyp}${jobOrder.ContHq === 1 ? "HQ" : ""}`
    }
  }
  return text
}
export const groupJobOrderByContSizeFull = (jobOrders) => {
  if (!jobOrders || jobOrders.length === 0) {
    return []
  }
  const groupedData = jobOrders.reduce((acc, jobOrder) => {
    const key = `${jobOrder.ContSize}-${jobOrder.ConttTyp}-${jobOrder.ContHq}`;
    if (!acc[key]) {
      let text = getContSizeText(jobOrder)
      acc[key] = {
        ContSize: jobOrder.ContSize,
        ContTyp: jobOrder.ContTyp,
        ContHq: jobOrder.ContHq,
        text: text,
        count: 0,
        NumJobOrd: 0,
        ShpmId: jobOrder.ShpmId || 0,
      };
    }
    acc[key].count++;
    acc[key].NumJobOrd++;
    return acc;
  }, {});
  return Object.values(groupedData);
}
const initFiles = {
  serverFiles: [],
  addedFiles: [],
  deletedFiles: [],
}
const shpTypCombo = [
  { id: 1, label: "เรือ" },
  { id: 2, label: "รถ" },
  { id: 3, label: "เครื่องบิน" },
  { id: 4, label: "รถไฟ" },
]
// const NumberObject = ({ children, label }) => {
//   return (
//     <BoxFR>
//       <Typography fontWeight="bold">{label}</Typography>
//       {children}
//     </BoxFR>
//   )
// }

let oData = {}

let originalFileUploadDataBL = null;
let originalFileUploadDataFrt = null;
let originalFileUploadDataCstm = null;

const ShippingInvoiceImportDialog = ({ selectedId, dialogOpen, setDialogOpen, onFinish, lastFilter }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const { user } = useContext(UserContext)
  const [dialogData, setDialogData] = useState({ ...initShippingInvoiceImportData })
  const [dialogContainerVolOpen, setDialogContainerVolOpen] = useState(false)
  const [blFiles, setBLFiles] = useState({ ...initFiles })
  const [frtFiles, setFrtFiles] = useState({ ...initFiles })
  const [cstmFiles, setCstmFiles] = useState({ ...initFiles })
  const [dialogCusOpen, setDialogCusOpen] = useState(false)
  const [dialogJobOpen, setDialogJobOpen] = useState(false)
  const [dialogReadFileOpen, setDialogReadFileOpen] = useState(false)

  const cneeMemo = useMemo(() => {
    const ctt = msData.cusCombo.find(c => c.id === ownCompanyCusId)
    const othCus = msData.cusCombo.filter(c => c.id !== ownCompanyCusId)
    if(ctt){
      ctt.group = "บริษัท"
      return [ctt, ...othCus.map(c => ({ ...c, group: "บริษัทอื่นๆ" }))]
    }
    return msData.cusCombo
  }, [msData.cusCombo])

  const jobCombo = useMemo(() => {
    let result = null
    if (dialogData.CusId) {
      result = msData.jobCombo.filter(item => item.refId === dialogData.CusId).map(item => item)
      result.push({ id: -1, label: "เพิ่มงานใหม่", group: "เพิ่มข้อมูล" })
    } else {
      result = []
    }
    return result
  }, [dialogData.CusId, msData.jobCombo])

  const handleSelectCusCombo = useCallback((id) => {

    setDialogData(o => {
      if (id === -1) {
        setDialogCusOpen(true)
      }
      return { ...o, CusId: id }
    })
    // console.log("handleSelectCusCombo", id)
    // console.log("msData.jobCombo", msData.jobCombo)
    // setJobCombo(msData.jobCombo.filter(j => j.refId === id))
  }, [])

  const handleSelectJobCombo = useCallback((id) => {
    setDialogData(o => {
      if (id === -1) {
        setDialogJobOpen(true)
      }
      return { ...o, JobId: id }
    })
  }, [])
  const textFieldProps = useCallback((name) => ({
    size: "small",
    sx: { width: 190 },
    label: shippingInvoiceColNm[name],
    value: dialogData[name] ?? "",
    onChange: (e) => setDialogData(o => ({ ...o, [name]: e.target.value })),
  }), [dialogData])

  const dateTimePickerProp = useCallback((name, required) => ({
    label: shippingInvoiceColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: dialogData[name],
    InputAdornmentProps: { style: { marginLeft: 0 } },
    // disableOpenPicker: disabled,
    // disabled: disabled,
    onChange: (newValue) => { setDialogData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) => <TextField
      size="small" {...params}
      sx={{ width: 190 }}
      required={required}
      error={required && !dialogData[name]} />,
  }), [dialogData])

  const generateJobNo = useCallback(() => {
    ax.post(branchApiNm.generateJobNo, dialogData).then(value => {
      if (value.data) {
        setDialogData(o => ({ ...o, JobNo: value.data }))
      }
    })
  }, [ax, dialogData])

  const hanleOpenContainerVolDialog = useCallback(() => {
    setDialogContainerVolOpen(true)
  }, [])

  const handleJobOrderVolFinish = useCallback((jobOrders) => {
    const groupedArray = groupJobOrderByContSizeFull(jobOrders)

    console.log('Grouped job orders:', groupedArray);

    setDialogData(o => ({
      ...o,
      GroupJobOrders: jobOrders,
      Vol: groupedArray.map(item => `${item.count}x${item.text}`).join(", ")
    }))
  }, [])

  const handleDialogOk = useCallback(async () => {
    if (!dialogData.RecvDocDte || !dialogData.JobNo || !dialogData.JobId || !dialogData.CusId) {
      alert("กรุณาตรวจสอบข้อมูลให้ครบถ้วน")
      return
    }
    let hasChange = false
    const contNos = dialogData.ContNoStr ? dialogData.ContNoStr.toUpperCase().split(/[\n,]+/).map(no => no.trim()).filter(no => no) : []
    let shpInvId = dialogData.ShpInvId
    if (!dialogData.ShpInvId) {


      const postData = {
        ...dialogData,
        ContNos: contNos,
        DemFreeTm: dialogData.DemFreeTm ? +dialogData.DemFreeTm : null,
        DetFreeTm: dialogData.DetFreeTm ? +dialogData.DetFreeTm : null,
        getArgs: null
      }
      console.log("postData", postData)
      const returnValue = await ax.post(shippingApiNm.insertShippingInvWithJobOrders, postData)
      if (returnValue.data) {
        shpInvId = returnValue.data
        // onFinish(value.data)
        // setDialogOpen(false)
        hasChange = true
      }
    } else {
      const shpmColValues = {}
      const shpColValues = {}
      const shpmCols = ["Bkg", "RecvDocDte", "ETA", "Vssl", "Voy", "Agnt", "JobNo", "CusId", "JobId", "ShpmTypId"]
      Object.keys(dialogData).forEach(key => {
        if (oData[key] !== dialogData[key] && key !== "ContNos" && key !== "ContNoStr" && key !== 'JobOrders' && key !== 'GroupJobOrders' && key !== 'Vol') {
          if (shpmCols.includes(key)) {
            shpmColValues[key] = dialogData[key]
          } else {
            shpColValues[key] = dialogData[key]
          }
        }
      })
      const newJobOrders = dialogData.GroupJobOrders.filter(jo => !jo.ShpmId)
      if (Object.keys(shpColValues).length > 0) {
        const postData = {
          ShpInvId: dialogData.ShpInvId,
          ColValues: shpColValues,
        }
        await ax.post(shippingApiNm.updateShippingInvoiceColumns, postData)
        hasChange = true
      }
      if (Object.keys(shpmColValues).length > 0) {
        const postData = {
          ShpmId: dialogData.ShpmId,
          ColValues: shpmColValues,
        }
        await ax.post(shippingApiNm.updateShipmentColumns, postData)
        hasChange = true
      }
      if (JSON.stringify(oData.ContNos || []) !== JSON.stringify(contNos)) {
        hasChange = true
        await ax.post(shippingApiNm.updateShippingContNos, { ShpInvId: shpInvId, ContNos: contNos })
      }
      if (newJobOrders.length > 0) {
        hasChange = true
        hasChange = true
        const postData = {
          GroupJobOrders: newJobOrders,
          ShpmId: dialogData.ShpmId,
          TakePOIID: dialogData.TakePOIId,
          RtnPOIID: dialogData.RtnPOIId,
          TakeDteSt: dialogData.TakeDteSt,
          RtnDteSt: dialogData.RtnDteSt,
          RtnDteEn: dialogData.RtnDteEn,
          JobId: dialogData.JobId,
        }
        await ax.post(shippingApiNm.insertJobOrders, postData)
      }


    }
    const localSaveFile = (fileUploadData, setFileUploadData, ShpFileTypId) => saveFile({
      ax,
      alertWarning: alertWarning,
      fileUploadData: fileUploadData,
      setFileUploadData: setFileUploadData,
      apiUpdateFileName: shippingApiNm.updateFileName,
      apiDeleteFile: shippingApiNm.deleteFile,
      apiAddFile: shippingApiNm.uploadFile,
      key: "ShpFileId",
      refKey: "ShpInvId",
      refValue: shpInvId,
      extraColValues: { ShpFileTypId: ShpFileTypId }
    })
    if (originalFileUploadDataBL !== JSON.stringify(blFiles)) {
      hasChange = true
      localSaveFile(blFiles, setBLFiles, 8)
    }
    if (originalFileUploadDataFrt !== JSON.stringify(frtFiles)) {
      hasChange = true
      localSaveFile(frtFiles, setFrtFiles, 10)
    }
    if (originalFileUploadDataCstm !== JSON.stringify(cstmFiles)) {
      hasChange = true
      localSaveFile(cstmFiles, setCstmFiles, 14)
    }
    if (hasChange) {
      onFinish(null)
    }
    setDialogOpen(false)
    // console.log('Changed fields:', ColValues)
  }, [ax, dialogData, onFinish, setDialogOpen, blFiles, cstmFiles, frtFiles])

  const handleDeleteShippingInvoice = useCallback(() => {
    if (dialogData.ShpInvId) {
      Swal.fire({
        text: "ต้องการลบข้อมูลใบแจ้งลากด้วยหรือไม่?",
        icon: 'question',
        showDenyButton: true,
        denyButtonText: `ลบเฉพาะข้อมูล Shipping`,
        confirmButtonText: 'ลบข้อมูลทั้งหมด',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        denyButtonColor: '#9c27b0',
        cancelButtonColor: '#d33',
      }).then((result) => {
        let postData = null
        if (result.isConfirmed) {
          postData = { ShpInvId: dialogData.ShpInvId, WithShipment: 1, ShpmId: dialogData.ShpmId }
        } else if (result.isDenied) {
          postData = { ShpInvId: dialogData.ShpInvId }
        }
        if (postData) {
          if (postData.WithShipment) {
            if (dialogData.JobOrders.length > 0) {
              alertError("ไม่สามารถลบข้อมูลได้ เนื่องจากมีงบงานที่เกี่ยวข้องผูกอยู่")
              return
            }
          }
          ax.post(shippingApiNm.deleteShippingInvoice, postData).then(value => {
            if (value.data) {
              onFinish(null)
              setDialogOpen(false)
            }
          })
        }
      })
    }
  }, [ax, dialogData.ShpInvId, dialogData.ShpmId, dialogData.JobOrders.length, onFinish, setDialogOpen])

  const handleSearch = useCallback(() => {
    var win = window.open(window.location.origin + `/emily/DailyJob/ShpmId/${dialogData.ShpmId}`, '_blank');
    win.focus();
  }, [dialogData.ShpmId])

  const onDialogCusFinish = useCallback(async (id) => {
    setDialogData(o => ({ ...o, CusId: id }))
  }, [])

  const onDialogJobFinish = useCallback(async (id) => {
    setDialogData(o => ({ ...o, JobId: id }))
  }, [])

  const onDialogReadBLFinish = useCallback((data) => {
    console.log("onDialogReadBLFinish", data)
    setDialogData(o => {
      return {
        ...o,
        Agnt: data.Agnt,
        Bkg: data.Bkg,
        CT: data.CT,
        CneeId: data.CneeId,
        ContNos: data.ContNos,
        ETA: data.ETA,
        KGM: data.KGM,
        M3: data.M3,
        Port: data.Port,
        GroupJobOrders: data.VolArr ? data.VolArr.map(vo => ({
          NumJobOrd: vo.Qty,
          ContSize: vo.ContSize,
          ContTyp: vo.ContTyp,
          ContHq: vo.ContHq,
          TlrTypId: 1,
          FullWt: vo.FullWt || "",
        })) : [],
        Vssl: data.Vssl,
        Voy: data.Voy,
      }
    })

    setBLFiles(o => ({
      ...o,
      addedFiles: [
        ...o.addedFiles,
        {
          file: data.file,
          fileNm: data.file.name,
          label: data.file.name,
          isEdit: false,
          imgLink: URL.createObjectURL(data.file)
        }
      ]
    }))
  }, [])

  const customerDialogPropsMemo = useMemo(() => {
    return {
      state: { dialogOpen: dialogCusOpen, selectedCusId: 0 },
      fn: {
        setDialogOpen: setDialogCusOpen,
        onFinish: onDialogCusFinish
      }
    }
  }, [dialogCusOpen, onDialogCusFinish])

  const jobDialogPropsMemo = useMemo(() => {
    return {
      state: { dialogOpen: dialogJobOpen, selectedId: 0, selectedCusId: dialogData.CusId },
      fn: {
        setDialogOpen: setDialogJobOpen,
        onFinish: onDialogJobFinish
      }
    }
  }, [dialogJobOpen, onDialogJobFinish, dialogData.CusId])

  useEffect(() => {
    if (dialogOpen) {
      if (!selectedId) {
        console.log("initShippingInvoiceImportData", initShippingInvoiceImportData)
        setDialogData({
          ...initShippingInvoiceImportData,
          RecvDocDte: dayjs(),
          BLRecvTm: dayjs(),
          ManAccId: user.AccId
        })
      } else {
        ax.post(shippingApiNm.getShippingInvoiceDetail, { ShpInvId: selectedId }).then(value => {
          if (value.data) {

            const getFileObj = file => ({
              id: file.ShpFileId,
              fileNm: file.FileNm,
              label: file.Label,
              oLabel: file.Label,
              ShpInvId: selectedId,
              isEdit: false,
              file: null,
              imgLink: `${window.location.origin}/file/shipping/${file.ShpInvId}/${file.FileNm}`,
            })
            const serverFilesBL = value.data[0].Files.filter(file => file.ShpFileTypId === 8).map(getFileObj)
            const serverFilesFrt = value.data[0].Files.filter(file => file.ShpFileTypId === 10).map(getFileObj)
            const serverFilesCstm = value.data[0].Files.filter(file => file.ShpFileTypId === 14).map(getFileObj)

            setBLFiles(o => {
              const newData = { ...o, serverFiles: serverFilesBL }
              originalFileUploadDataBL = JSON.stringify(newData)
              return newData
            })
            setFrtFiles(o => {
              const newData = { ...o, serverFiles: serverFilesFrt }
              originalFileUploadDataFrt = JSON.stringify(newData)
              return newData
            })
            setCstmFiles(o => {
              const newData = { ...o, serverFiles: serverFilesCstm }
              originalFileUploadDataCstm = JSON.stringify(newData)
              return newData
            })

            const groupedArray = groupJobOrderByContSizeFull(value.data[0].JobOrders)
            console.log('Grouped job orders:', groupedArray);
            // setJobCombo(msData.jobCombo.filter(j => j.refId === value.data[0].CusId))
            oData = { ...value.data[0], JobOrders: value.data[0].JobOrders.map(j => ({ ...j, })) }
            setDialogData({
              ...value.data[0],
              GroupJobOrders: groupedArray,
            })
          }
        })
      }
    } else {
      setDialogData({ ...initShippingInvoiceImportData })
      // setJobCombo([])
      setBLFiles({
        serverFiles: [],
        addedFiles: [],
        deletedFiles: [],
      })
      setFrtFiles({
        serverFiles: [],
        addedFiles: [],
        deletedFiles: [],
      })
      setCstmFiles({
        serverFiles: [],
        addedFiles: [],
        deletedFiles: [],
      })
    }
  }, [dialogOpen, ax, selectedId, user.AccId])

  useEffect(() => {
    if (dialogData.GroupJobOrders) {
      setDialogData(o => ({ ...o, Vol: o.GroupJobOrders?.map(vo => `${vo.NumJobOrd}x${getContSizeText(vo)}`)?.join(", ") }))
    }
  }, [dialogData.GroupJobOrders])

  useEffect(() => {
    if (dialogData.ContNos) {
      setDialogData(o => ({ ...o, ContNoStr: dialogData.ContNos.map(contNo => contNo.trim()).join("\n") }))
    }
  }, [dialogData.ContNos])

  console.log("dialogData::", dialogData)
  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth
      PaperProps={{ sx: { maxWidth: 1650, minWidth: 1650, width: 1650 } }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายละอียดงาน"
        onDeleteClick={handleDeleteShippingInvoice}
      >
        <BoxFR ml={2}>
          <Button variant="contained" color="secondary" onClick={() => { setDialogReadFileOpen(true) }}>
            <DocumentScannerRounded sx={{ mr: 1 }} />
            อ่านไฟล์ B/L</Button>
        </BoxFR>
      </DialogHeader>
      <DialogContent>
        <BoxFR pt={2} sx={{ alignItems: "stretch" }}>
          <BoxFC sx={{ gap: 1 }}>
            <DateTimePickerCustomTime {...dateTimePickerProp("RecvDocDte", true)} />
            <TextField {...textFieldProps("ShpmTypId")} required select>
              {generateMenuComboItem(msData.ShpmTypCombo)}
            </TextField>
            <TextField {...textFieldProps("ShpTypId")} required select>
              {generateMenuComboItem(shpTypCombo)}
            </TextField>
            <ComboBox sx={{ width: 190 }} options={msData.cusComboWithAdd} label={shippingInvoiceColNm.CusSNm}
              selectedId={dialogData.CusId} required={true}
              setSelectedId={handleSelectCusCombo}
            />
            <ComboBox sx={{ width: 190 }} options={jobCombo} label={shippingInvoiceColNm.JobSNm}
              selectedId={dialogData.JobId} required={true}
              setSelectedId={handleSelectJobCombo}
            />
            <ComboBox sx={{ width: 190 }} options={cneeMemo} label={shippingInvoiceColNm.Cnee}
              selectedId={dialogData.CneeId}
              setSelectedId={(id) => setDialogData(o => ({ ...o, CneeId: id }))}
            />
            <TextField {...textFieldProps("JobNo")} required={true} error={!dialogData.JobNo}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton sx={{ p: 0 }} onClick={generateJobNo}>
                    <AutoAwesomeIcon />
                  </IconButton>
                </InputAdornment>
              }}
            />
            <TextField {...textFieldProps("Agnt")} />
            <TextField {...textFieldProps("Vssl")} />
            <TextField {...textFieldProps("Voy")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("ETA")} />
            <TextField {...textFieldProps("Vol")}
              InputProps={{
                endAdornment: <InputAdornment position="end" sx={{ padding: 0, margin: 0 }}>
                  <IconButton sx={{ p: 0 }} onClick={hanleOpenContainerVolDialog}>
                    <ArticleRounded />
                  </IconButton>
                </InputAdornment>
              }} />
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <ComboBox sx={{ width: 190 }} options={msData.accountCombo} label={shippingInvoiceColNm.ManAccId}
              selectedId={dialogData.ManAccId}
              setSelectedId={(id) => setDialogData(o => ({ ...o, ManAccId: id }))}
            />
            <TextField {...textFieldProps("IP_InvNo")} />
            <TextField {...textFieldProps("Bkg")} label="B/L NO." />
            <TextField {...textFieldProps("CT")} />
            <TextField {...textFieldProps("KGM")} />
            <TextField {...textFieldProps("M3")} />
            <TextField {...textFieldProps("DemFreeTm")} {...endAdornmentProps("วัน")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("DemStDte")} />
            <TextField {...textFieldProps("DetFreeTm")} {...endAdornmentProps("วัน")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("DetStDte")} />
            {/* <Box height={40}></Box> */}

            <DateTimePickerCustomTime {...dateTimePickerProp("SealContTm")} />
            <Button variant="contained" onClick={handleSearch}>
              <ReplyRounded sx={{ transform: "scaleX(-1)" }} />
              ดูข้อมูลตู้ในหน้า 1.3
            </Button>
            {/* <DateTimePickerCustomTime {...dateTimePickerProp("ETA")} /> */}
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <DateTimePickerCustomTime {...dateTimePickerProp("BLRecvTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("BLCfTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("BLSndTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("ANRecvTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("MBLEntrTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("FrtInvTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("FrtInvPaidTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("DOMailTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("DORecvTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("CstmFormDfTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("CstmFormCfTm")} />
            <DateTimePickerCustomTime {...dateTimePickerProp("CstmClrTm")} />
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <CheckboxFormControl label={shippingInvoiceColNm.IsOwnTuk} checked={dialogData.IsOwnTuk === 1}
              onChange={(e) => setDialogData(o => ({ ...o, IsOwnTuk: e.target.checked ? 1 : 0 }))} />
            <ComboBox sx={{ width: 190 }} options={msData.subContractCombo} label="จ้าง Shipping"
              selectedId={dialogData.ScId}
              setSelectedId={(id) => setDialogData(o => ({ ...o, ScId: id }))}
            />
            <TextField {...textFieldProps("Note")} multiline rows={9.5} />
            <TextField {...textFieldProps("ContNoStr")} label="หมายเลขตู้" multiline rows={10} />
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <Typography variant="h6"> ไฟล์ ก่อนเรือเข้า</Typography>
            {/* <FileDropPanel height="100%" selectedFiles={blFiles} setSelectedFiles={setBLFiles} /> */}
            <FileUpload
              width={265}
              options={["B/L", "Form E"]}
              fileUploadData={blFiles}
              setFileUploadData={setBLFiles}
            />
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <Typography variant="h6"> ไฟล์ สายเรือ</Typography>
            {/* <FileDropPanel height="100%" selectedFiles={blFiles} setSelectedFiles={setBLFiles} /> */}
            <FileUpload
              width={265}
              options={["Inv สายเรือ", "Pay in slip"]}
              fileUploadData={frtFiles}
              setFileUploadData={setFrtFiles}
            />
          </BoxFC>
          <BoxFC sx={{ gap: 1 }}>
            <Typography variant="h6"> ไฟล์ ศุลกากร</Typography>
            {/* <FileDropPanel height="100%" selectedFiles={blFiles} setSelectedFiles={setBLFiles} /> */}
            <FileUpload
              width={265}
              options={["ใบขน", "ล่วงเวลา"]}
              fileUploadData={cstmFiles}
              setFileUploadData={setCstmFiles}
            />
          </BoxFC>
          {/* <BoxFC sx={{ gap: 1, width: 250 }}>
            <Typography variant="h6">ไฟล์ สายเรือ</Typography>
            <FileDropPanel height="100%" selectedFiles={frtFiles} setSelectedFiles={setFrtFiles} />
          </BoxFC>
          <BoxFC sx={{ gap: 1, width: 250 }}>
            <Typography variant="h6">ไฟล์ ศุลกากร</Typography>
            <FileDropPanel height="100%" selectedFiles={cstmFiles} setSelectedFiles={setCstmFiles} />
          </BoxFC> */}
        </BoxFR>
        <ContainerVolDialog
          dialogOpen={dialogContainerVolOpen}
          setDialogOpen={setDialogContainerVolOpen}
          initJobOrderData={dialogData.GroupJobOrders}
          onFinish={handleJobOrderVolFinish}
        />
        <CustomerDialog {...customerDialogPropsMemo} />
        <JobDialog {...jobDialogPropsMemo} />
        <ReadBLDialog
          dialogOpen={dialogReadFileOpen}
          setDialogOpen={setDialogReadFileOpen}
          onFinish={onDialogReadBLFinish} />
      </DialogContent>
      <DialogFooter okText={"บันทึก"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(ShippingInvoiceImportDialog

)